$( window ).on( "load", function() {
	$('#product-description-content h2, #product-description-content h3').each( function() {
		var title = $(this).html();
		var anchor = title.replace(' ', '-');
		$(this).prepend('<a name="' + anchor + '" class="anchor"></a>');
		$('#product-description-nav .container').append('<a href="#' + anchor + '">' + title + '</a>');
	});
    $('#product-description-nav .container').append('<a href="#Reviews">Reviews</a>');
	$('a[href^="#"]').click(function(e) {
		e.preventDefault();
		var dest = $(this).attr('href').replace("#","");
		$('html,body').animate({ scrollTop: $('a[name="' + dest + '"]').offset().top }, 'slow');
	});
    $('.faq-question').click( function() {
      $(this).toggleClass('expanded');
      $(this).siblings('.faq-answer').slideToggle();
    });

    $('.homepage-banner-slider').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		lazyLoad: 'progressive',
    });

    $('.recipe-preview-content .button').each( function() {
    	$(this).colorbox({width: '850px', maxWidth: '80%', maxHeight: '80%', html: $(this).parent().parent().siblings('.recipe-modal-content').html()});
    });

    $("#product-description-nav-container").sticky({topSpacing:150});
});